import { render, staticRenderFns } from "./TaskMessageBox.vue?vue&type=template&id=25a6669c&scoped=true&"
import script from "./TaskMessageBox.vue?vue&type=script&lang=js&"
export * from "./TaskMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./TaskMessageBox.vue?vue&type=style&index=0&id=25a6669c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6669c",
  null
  
)

export default component.exports